class BaseService extends AbstractClass
	@register: (module = null) ->
		@registerService module

	constructor: ->
		super(...arguments)

		@initialize?()
